###
#
# @file application
#
###

Lightbox = require('lightbox2/dist/js/lightbox.js')

class ApplicationDoctor

  constructor: (@app, config) ->

    ##
    # DOM Elements
    # @type {string}
    ##
    @el =
      body:                   'body'
      application_form:       '.application-doctor-review'
      action_button:          '[data-application-action]'
      action_input:           '[name="application[action]"]'
      health_dept_toggle:     '[data-health-dept-toggle]'
      health_dept_status:     '[data-health-dept-status]'

    @app.register_turbolinks_load_handler @init

    $(document).on 'click', @el.action_button, @application_action
    $(document).on 'change', '#doctor_notes', @doctor_notes_clear
    $(document).on 'change', @el.health_dept_toggle, @toggle_health_dept
    
  init: =>
    unless $(@el.body).hasClass 'doctors-applications'
      return

    @notes_container = $("#doctor_notes_container")
    @notes_error = @notes_container.find('.form-error')

    Lightbox.init()


  application_action: (e)=>
    e.preventDefault()
    action = $(e.currentTarget).data 'application-action'
    $(@el.action_input).val action

    if action == "denied" || action == "errors"
      if $("#doctor_notes").val() == ""
        @notes_container.addClass 'form-field--has-error'
        @notes_error.show()
        return false
      else
        $(@el.application_form).submit()
    else
      $(@el.application_form).submit()


  doctor_notes_clear: (e)=>
    @notes_container.removeClass 'form-field--has-error'
    @notes_error.hide()


  # Saves the "Trámite en Depto. de Salud" flag on the fly (AJAX) so the assistant
  # doesn't have to submit the whole application. The Health Dept. response can take
  # weeks, so the checkbox state persists independently. CSRF token is already added
  # to every AJAX request via $.ajaxSetup in doctor_dashboard.coffee.
  toggle_health_dept: (e)=>
    checkbox = $(e.currentTarget)
    status   = $(@el.health_dept_status)
    checked  = checkbox.is(':checked')

    checkbox.prop 'disabled', true

    $.ajax
      url: checkbox.data('url')
      type: 'PATCH'
      dataType: 'json'
      data: { value: (if checked then '1' else '0') }
      success: (response)=>
        checkbox.prop 'disabled', false
        if response.health_dept_submitted
          status.css('color', '#008C6B').text "✓ Guardado"
          window.setTimeout (->
            status.text(if response.submitted_ago then "(marcado #{response.submitted_ago})" else "")
          ), 2000
        else
          status.text ''
      error: =>
        checkbox.prop 'disabled', false
        # Revert the visual state so it reflects what's actually stored.
        checkbox.prop 'checked', !checked
        status.css('color', '#EA125F').text "No se pudo guardar. Intente de nuevo."



module.exports = ApplicationDoctor
